import { useQuery } from '@tanstack/react-query';

import { authApi, type WikiMeDto } from '../../lib/authApi';
import { crmFeedbackApi, feedbackGate, type WidgetInfo } from '../../lib/feedback';
import { isPartner } from '../../lib/nav';

export interface FeedbackGate {
  me: WikiMeDto | undefined;
  /** Сотрудник iiko: без аккаунта CRM, свой путь отправки. */
  isIiko: boolean;
  /** Партнёр (франчайзи): «Мои обращения» открывают CRM. */
  partner: boolean;
  /** Виджет включён (CRM может выключить его роли). */
  feedbackOn: boolean;
  /** «Вопрос в УК» включён. */
  questionOn: boolean;
  /** Ответ `GET /feedback/widget` (только CRM-пользователь, пока не пришёл — undefined). */
  info: WidgetInfo | undefined;
}

/**
 * Один источник правды для плавающего «+» (HelpFab) и «Создать ▾» (CreateMenu): кто смотрит
 * и какие пункты ему положены. Запрос виджета общий (кэш react-query), в сеть ходит раз в минуту.
 */
export function useFeedbackGate(): FeedbackGate {
  const me = useQuery({ queryKey: ['wiki-auth', 'me'], queryFn: () => authApi.me(), retry: false, staleTime: 60_000 }).data;
  const isIiko = me?.type === 'iiko_employee';
  const widget = useQuery({
    queryKey: ['wiki', 'feedback', 'widget'],
    queryFn: crmFeedbackApi.widget,
    enabled: !!me && !isIiko,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
  });
  const info = isIiko ? undefined : widget.data;
  return { me, isIiko, partner: isPartner(me), info, ...feedbackGate(isIiko, info) };
}
